module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-logo-0d30258652de562026f31a3ee8cc7687.svg";